var paragraph_default = {
  "fontElementMap": "cxWup",
  "elementSpacing": "Twp3y",
  "text": "qWK-6 Twp3y",
  "child": "AT4Tn"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph.scss.js.map
